import script from "./Well365.vue?vue&type=script&setup=true&lang=js"
export * from "./Well365.vue?vue&type=script&setup=true&lang=js"

import "./Well365.vue?vue&type=style&index=0&id=395a3d68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-395a3d68"]])

export default __exports__